import AssignmentIcon from "@mui/icons-material/Assignment";
import { IconButton, Tooltip, Zoom } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { NAV_ROUTES } from "components/NavigationBar/routes";
import { useRoleContext } from "hooks";

export function ShipmentTrackingSheetNavBarButton() {
  const { role } = useRoleContext();
  const navigate = useNavigate();

  const onClick = () => {
    navigate(NAV_ROUTES.SHIPMENT_TRACKING);
  };

  if (role?.company == null || role.type !== "SHIPPER") {
    return null;
  }

  return (
    <Tooltip
      title="Shipment Tracking"
      placement="right"
      TransitionComponent={Zoom}
    >
      <IconButton color="inherit" onClick={onClick}>
        <AssignmentIcon fontSize="large" />
      </IconButton>
    </Tooltip>
  );
}
